"use client";

import { FC } from "react";
import { useTheme } from "next-themes";
import { Icon } from "@iconify/react";
import {
  Dropdown,
  DropdownTrigger,
  DropdownMenu,
  DropdownItem,
} from "@heroui/dropdown";
import { Button } from "@heroui/button";
import { cn } from "@heroui/theme";

export interface ThemeSwitchProps {
  className?: string;
}

const ThemeSwitch: FC<ThemeSwitchProps> = ({ className }) => {
  const { theme, setTheme, resolvedTheme } = useTheme();

  const icon =
    theme === "system"
      ? "solar:laptop-bold-duotone"
      : resolvedTheme === "dark"
        ? "solar:moon-bold-duotone"
        : "solar:sun-bold-duotone";

  return (
    <Dropdown placement="bottom-end">
      <DropdownTrigger>
        <Button
          isIconOnly
          aria-label="Theme switch"
          className={cn("text-sub-600 rounded-full", className)}
        >
          <Icon icon={icon} width="22" />
        </Button>
      </DropdownTrigger>

      <DropdownMenu
        aria-label="Theme selection"
        itemClasses={{
          base: `
          `,
        }}
        onSelectionChange={(keys) => {
          const value = Array.from(keys).at(0) as string;
          setTheme(value);
        }}
        // itemClasses={{
        //   base: "data-[selected=true]:bg-neutral-200",
        // }}
        selectionMode="single"
        // className="dark:bg-neutral-100"
        selectedKeys={theme ? [theme] : ["system"]}
      >
        <DropdownItem
          key="light"
          startContent={<Icon icon="solar:sun-bold-duotone" width="20" />}
        >
          Light
        </DropdownItem>

        <DropdownItem
          key="dark"
          startContent={<Icon icon="solar:moon-bold-duotone" width="20" />}
        >
          Dark
        </DropdownItem>

        <DropdownItem
          key="system"
          startContent={<Icon icon="solar:laptop-bold-duotone" width="20" />}
        >
          System
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};

export default ThemeSwitch;
